/* ZAYIN UI Motion System v1 — intentionally independent from Shopify cart/nav internals. */
(() => {
  'use strict';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduced.matches) return;

  const revealTargets = new WeakSet();
  const observer = ('IntersectionObserver' in window)
    ? new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.setAttribute('data-zayin-reveal', 'entered');
          obs.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -24px 0px', threshold: 0.01 })
    : null;

  function enhanceSections(root = document) {
    if (!observer || reduced.matches) return;
    const main = document.getElementById('MainContent');
    if (!main) return;
    const sections = [...main.children].filter(el => el.classList?.contains('shopify-section'));
    if (sections.length < 2) return;
    let enhanced = false;
    sections.forEach((section, index) => {
      if (index === 0 || revealTargets.has(section)) return; // hero/LCP must remain immediately visible
      if (!root.contains(section) && root !== document) return;
      revealTargets.add(section);
      // Never hide content that is already on the initial viewport.
      if (section.getBoundingClientRect().top < window.innerHeight * .91) {
        section.setAttribute('data-zayin-reveal', 'entered');
        return;
      }
      section.setAttribute('data-zayin-reveal', 'waiting');
      observer.observe(section);
      enhanced = true;
    });
    if (enhanced) document.documentElement.classList.add('zayin-motion-enabled');
  }

  function animateClick(event) {
    if (reduced.matches || !(event.target instanceof Element)) return;
    const target = event.target.closest(
      '#MainContent a.button:not(.button-unstyled), ' +
      '#MainContent button.button:not(.button-unstyled), ' +
      '#MainContent a.button-secondary, ' +
      '#MainContent button.button-secondary, ' +
      '#MainContent .zw-style-card .quick-add__button'
    );
    if (!target || target.disabled || target.closest('.shopify-payment-button, .shopify-cleanslate')) return;
    if (target.classList.contains('zayin-click-target')) return; // avoid stacking click effects
    target.classList.add('zayin-click-target');
    const rect = target.getBoundingClientRect();
    const x = event.clientX ? event.clientX - rect.left : rect.width / 2;
    const y = event.clientY ? event.clientY - rect.top : rect.height / 2;
    const ripple = document.createElement('span');
    ripple.className = 'zayin-click-ripple';
    ripple.setAttribute('aria-hidden', 'true');
    ripple.style.left = x + 'px';
    ripple.style.top = y + 'px';
    target.append(ripple);
    ripple.addEventListener('animationend', () => {
      ripple.remove();
      target.classList.remove('zayin-click-target');
    }, { once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhanceSections(), { once: true });
  } else {
    enhanceSections();
  }
  document.addEventListener('click', animateClick, { passive: true });
  document.addEventListener('shopify:section:load', event => enhanceSections(event.target));
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('#MainContent > .shopify-section[data-zayin-reveal="waiting"]').forEach(section => {
      if (section.getBoundingClientRect().top < window.innerHeight) {
        section.setAttribute('data-zayin-reveal', 'entered');
        observer?.unobserve(section);
      }
    });
  });
  reduced.addEventListener?.('change', event => {
    if (!event.matches) return;
    observer?.disconnect();
    document.querySelectorAll('[data-zayin-reveal]').forEach(section => section.setAttribute('data-zayin-reveal', 'entered'));
  });
})();
